import axios from "./axios";

export default {
  namespaced: true,

  state: {
    publicUsername: [],
    publicDetails: [],
    publicAllergies: [],
    publicConditions: [],
    publicVaccines: [],
    publicDevices: [],
    publicMedications: [],
    publicFiles: [],
    publicIce: []
  },
  getters: {
    gPublicUsername(state) {
      return state.publicUsername;
    },
    gPublicDetails(state) {
      return state.publicDetails;
    },
    gPublicConditions(state) {
      return state.publicConditions;
    },
    gPublicAllergies(state) {
      return state.publicAllergies;
    },
    gPublicVaccines(state) {
      return state.publicVaccines;
    },
    gPublicDevices(state) {
      return state.publicDevices;
    },
    gPublicMedications(state) {
      return state.publicMedications;
    },
    gPublicFiles(state) {
      return state.publicFiles;
    },
    gPublicIce(state) {
      return state.publicIce;
    }
  },
  actions: {
    aAll({ commit, rootGetters, rootState }, code) {
      return new Promise((resolve, reject) => {
        var uri = 'profile/preview/';
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + rootState.userauth.token;
        axios.get(uri + rootGetters['user/gCurrentProfile'] + "/"+ code)
          .then(response => {
            if (response.data.status) {
              if (response.data.data.username !== []) {
                commit('SetPublicUserName', response.data.data.username)
              } else {
                //
              }

              if (response.data.data.details !== []) {
                commit('SetPublicDetails', response.data.data.details)
              } else {
                //
              }

              if (response.data.data.devices !== []) {
                commit('SetPublicDevices', response.data.data.devices)
              } else {
                //
              }

              if (response.data.data.vaccines !== []) {
                commit('SetPublicVaccines', response.data.data.vaccines)
              } else {
                //
              }

              if (response.data.data.conditions !== []) {
                commit('SetPublicConditions', response.data.data.conditions)
              } else {
                //
              }

              if (response.data.data.allergies !== []) {
                commit('SetPublicAllergies', response.data.data.allergies)
              } else {
                //
              }

              if (response.data.data.medications !== []) {
                commit('SetPublicMedications', response.data.data.medications)
              } else {
                //
              }

              if (response.data.data.files !== []) {
                commit('SetPublicFiles', response.data.data.files)
              } else {
                //
              }
              //console.log(response)
              if (response.data.data.ice !== []) {
                commit('SetPublicIce', response.data.data.ice)
              }
            }

            if (response.data.error) {
              commit('SetPublicError', response.data.error)
              resolve(false)
            }
            resolve(true)
          })
          .catch(error => {
            console.log(error.response)
            reject(0)
          })
      })
    }
  },
  mutations: {
    SetPublicError(state, error) {
      state.errors = error
    },
    SetPublicIce(state, ice) {
      state.publicIce = ice
    },
    SetPublicUserName(state, username) {
      state.publicUsername = username
    },
    SetPublicDetails(state, details) {
      state.publicDetails = details
    },
    SetPublicDevices(state, devices) {
      state.publicDevices = devices
    },
    SetPublicConditions(state, conditions) {
      state.publicConditions = conditions
    },
    SetPublicAllergies(state, allergies) {
      state.publicAllergies = allergies
    },
    SetPublicVaccines(state, vaccines) {
      state.publicVaccines = vaccines
    },
    SetPublicMedications(state, meds) {
      state.publicMedications = meds
    },
    SetPublicFiles(state, files) {
      state.publicFiles = files
    }
  }
}